"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URL_PARAMS_TO_EXTRACT = exports.CW_TIMESTAMP = exports.NON_BRANDED_USER_STR = exports.BRANDED_USER_STR = exports.TIKTOK_SEARCH = exports.FACEBOOK_SEARCH = exports.TWITTER_SEARCH = exports.REDDIT_SEARCH = exports.QUORA_SEARCH = exports.YOUTUBE_SEARCH = exports.BING_SEARCH = exports.GOOGLE_SEARCH = exports.FUI = exports.MOBILE = exports.TIKTOK_CLICK_IDENTIFIER = exports.MICROSOFT_CLICK_IDENTIFIER = exports.GOOGLE_CLICK_IDENTIFIER = exports.FACEBOOK_CLICK_IDENTIFIER = exports.SRC = exports.PROMO_CODE = exports.IMPRESSION_DEVICE = exports.UTM_MEDIUM = exports.AD_ID = exports.AD_NAME = exports.AD_SOURCE = exports.AD_SET_ID = exports.AD_SET_NAME = exports.AD_SET_SOURCE = exports.SEARCH_TERM = exports.CAMPAIGN_SOURCE_ID = exports.CAMPAIGN_SOURCE = exports.SITE_SOURCE = exports.FACEBOOK_PIXEL_IDENTIFIER_FIELD_NAME = exports.FACEBOOK_PIXEL_IDENTIFIER = exports.FACEBOOK_CLICK_DATA_FIELD_NAME = exports.FACEBOOK_CLICK_DATA = exports.INSTALL_INFO_COOKIE = exports.SYNC_DEVICE_ID_URL_PARAM = exports.DEVICE_ID_COOKIE_EXPIRATION = exports.DEVICE_ID_COOKIE_NAME = exports.WORDTUNE_BASE_URL_PROD = exports.WORDTUNE_BASE_URL_STG = exports.ANALYTICS_LP_REWRITE_IDEA_PROMPTS_SHOWN = exports.ANALYTICS_LP_REWRITE_IDEA_PROMPTS_EXAMPLE_PRESSED = exports.IDEA_PROMPTS_DEFAULTE_TEXT = exports.WORDTUNE_EDITOR = exports.GO_TO_EDITOR = exports.LOCAL_STORAGE_REWRITE_COUNTER_KEY = exports.ANALYTICS_APP_LOADED = exports.APP_NAME = void 0;
exports.GOOGLE_CLIENT_ID_PROD = exports.GOOGLE_CLIENT_ID_STG = exports.CLICK_ORIGIN = exports.CALL_TO_ACTION_TEXT = exports.GA4_ANONYMOUS = exports.GA4_NOT_LOGGED_IN = exports.GA4_LOGGED_IN = exports.GA4_EVENT_SITE_TYPE = exports.GA4_EVENT = exports.REINSTALL_BUTTON_ID = exports.UNINSTALL_FORM_BUTTON_ID = exports.REINSTALL_CLICKED_ANALYTICS_EVENT = exports.UNINSTALL_FORM_SUBMITTED_ANALYTICS_EVENT = exports.IS_EXTENTION_USER_USER_PROPERTY = exports.UNINSTALL_PAGE_VIEWED_ANALYTICS_EVENT = exports.REWRITE_LINK_CLASS = exports.ADD_TO_CHROME_UNLOCK_CLASS_PODCASTS = exports.ADD_TO_CHROME_ENHANCE_CLASS_PODCASTS = exports.ADD_TO_CHROME_TONES_CLASS_PODCASTS = exports.ADD_TO_CHROME_CLASS_PODCASTS = exports.INSTALL_EXTENTION_CLASS_PODCASTS = exports.INSTALL_EXTENTION_CLASS = exports.EDITOR_BUTTON_CLASS = exports.STAGING_EXTENTION_ID_EDGE = exports.STAGING_EXTENTION_ID_CHROME = exports.PRODUCTION_EXTENTION_ID_EDGE = exports.PRODUCTION_EXTENTION_ID_CHROME = exports.EDGE_STORE_LINK = exports.CLICK_IDENTIFIERS = void 0;
exports.APP_NAME = "website";
exports.ANALYTICS_APP_LOADED = "LandingPageEntered";
exports.LOCAL_STORAGE_REWRITE_COUNTER_KEY = "lparc";
exports.GO_TO_EDITOR = "Go to Editor";
exports.WORDTUNE_EDITOR = "Wordtune Editor";
exports.IDEA_PROMPTS_DEFAULTE_TEXT = [
    "Hi Steve, so sorry for getting back to you this late.",
    "Customer service manager looking for an opportunity to use my people and operational skills to help with customer satisfaction.",
    "Because of my work ethic & impact I've had on the company, I believe I am entitled to a promotion.",
    "Unfortunately, I won’t be able to hand in this assignment on time because I’m sick. Would you consider giving me an extension? Thank you.",
    "Steve, I noticed that you shared some information with us that I’m not sure is correct. Could we look into it?",
];
exports.ANALYTICS_LP_REWRITE_IDEA_PROMPTS_EXAMPLE_PRESSED = "LandingPageRewriteIdeaExamplePressed";
exports.ANALYTICS_LP_REWRITE_IDEA_PROMPTS_SHOWN = "LandingPageRewriteIdeaShown";
exports.WORDTUNE_BASE_URL_STG = "http://app.wordtune-stg.com";
exports.WORDTUNE_BASE_URL_PROD = "http://app.wordtune.com";
// url params
exports.DEVICE_ID_COOKIE_NAME = "__wtDeviceId";
exports.DEVICE_ID_COOKIE_EXPIRATION = 60 * 60 * 24 * 400;
exports.SYNC_DEVICE_ID_URL_PARAM = "syncDeviceId";
exports.INSTALL_INFO_COOKIE = "InstallInfo";
exports.FACEBOOK_CLICK_DATA = "_fbc";
exports.FACEBOOK_CLICK_DATA_FIELD_NAME = "fbc";
exports.FACEBOOK_PIXEL_IDENTIFIER = "_fbp";
exports.FACEBOOK_PIXEL_IDENTIFIER_FIELD_NAME = "fbp";
exports.SITE_SOURCE = "utm_source";
exports.CAMPAIGN_SOURCE = "utm_campaign";
exports.CAMPAIGN_SOURCE_ID = "utm_campaign_id";
exports.SEARCH_TERM = "utm_term";
exports.AD_SET_SOURCE = "ad_set_source";
exports.AD_SET_NAME = "ad_set_name";
exports.AD_SET_ID = "ad_set_id";
exports.AD_SOURCE = "ad_source";
exports.AD_NAME = "ad_name";
exports.AD_ID = "ad_id";
exports.UTM_MEDIUM = "utm_medium";
exports.IMPRESSION_DEVICE = "impression_device";
exports.PROMO_CODE = "p";
exports.SRC = "src";
exports.FACEBOOK_CLICK_IDENTIFIER = "fbclid";
exports.GOOGLE_CLICK_IDENTIFIER = "gclid";
exports.MICROSOFT_CLICK_IDENTIFIER = "msclkid";
exports.TIKTOK_CLICK_IDENTIFIER = "ttclid";
exports.MOBILE = "mobile";
exports.FUI = "fui";
exports.GOOGLE_SEARCH = "google-search";
exports.BING_SEARCH = "bing";
exports.YOUTUBE_SEARCH = "Youtube";
exports.QUORA_SEARCH = "quora";
exports.REDDIT_SEARCH = "Reddit";
exports.TWITTER_SEARCH = "Twitter";
exports.FACEBOOK_SEARCH = "facebook";
exports.TIKTOK_SEARCH = "TikTok";
exports.BRANDED_USER_STR = "brand";
exports.NON_BRANDED_USER_STR = "nonbrand";
//CW = Conversion Window
exports.CW_TIMESTAMP = {
    [exports.FACEBOOK_SEARCH]: 7,
    [exports.TIKTOK_SEARCH]: 7,
    [exports.GOOGLE_SEARCH]: 30,
    [exports.BING_SEARCH]: 30,
    [exports.QUORA_SEARCH]: 30,
    [exports.REDDIT_SEARCH]: 30,
    [exports.TWITTER_SEARCH]: 30,
    [exports.YOUTUBE_SEARCH]: 60,
};
exports.URL_PARAMS_TO_EXTRACT = [
    exports.SITE_SOURCE,
    exports.CAMPAIGN_SOURCE,
    exports.CAMPAIGN_SOURCE_ID,
    exports.SEARCH_TERM,
    exports.AD_SET_SOURCE,
    exports.AD_SET_NAME,
    exports.AD_SET_ID,
    exports.AD_SOURCE,
    exports.AD_NAME,
    exports.AD_ID,
    exports.UTM_MEDIUM,
    exports.IMPRESSION_DEVICE,
    exports.PROMO_CODE,
    exports.SRC,
];
exports.CLICK_IDENTIFIERS = [
    exports.FACEBOOK_CLICK_IDENTIFIER,
    exports.GOOGLE_CLICK_IDENTIFIER,
    exports.MOBILE,
    exports.FUI,
    exports.MICROSOFT_CLICK_IDENTIFIER,
    exports.TIKTOK_CLICK_IDENTIFIER,
];
//extentions links
exports.EDGE_STORE_LINK = "https://microsoftedge.microsoft.com/addons/detail/wordtune-aipowered-wri/";
exports.PRODUCTION_EXTENTION_ID_CHROME = "nllcnknpjnininklegdoijpljgdjkijc";
exports.PRODUCTION_EXTENTION_ID_EDGE = "fgngodlaekdlibajobmkaklibdggemdd";
exports.STAGING_EXTENTION_ID_CHROME = "mmdimcomiaceclfekcgibfeobbndbopm";
exports.STAGING_EXTENTION_ID_EDGE = "nidiappnajhddfmkhiegkjdokhmhpkla";
// classes
exports.EDITOR_BUTTON_CLASS = "section-hero-editor-btn";
exports.INSTALL_EXTENTION_CLASS = "section-hero-install-btn";
exports.INSTALL_EXTENTION_CLASS_PODCASTS = "section-hero-install-btn-podcasts";
exports.ADD_TO_CHROME_CLASS_PODCASTS = "add-to-chrome-platforms-podcasts";
exports.ADD_TO_CHROME_TONES_CLASS_PODCASTS = "add-to-chrome-section-tones-podcasts";
exports.ADD_TO_CHROME_ENHANCE_CLASS_PODCASTS = "add-to-chrome-section-enhance-podcasts";
exports.ADD_TO_CHROME_UNLOCK_CLASS_PODCASTS = "add-to-chrome-section-unlock-podcasts";
// hover intetns
exports.REWRITE_LINK_CLASS = ".rewrite-link, .more-tabs-menu-link";
exports.UNINSTALL_PAGE_VIEWED_ANALYTICS_EVENT = "Uninstall";
exports.IS_EXTENTION_USER_USER_PROPERTY = "isExtensionUser";
exports.UNINSTALL_FORM_SUBMITTED_ANALYTICS_EVENT = "UninstallFormSubmitted";
exports.REINSTALL_CLICKED_ANALYTICS_EVENT = "ReinstallExtensionPressed";
exports.UNINSTALL_FORM_BUTTON_ID = "uninstallFeedbackForm";
exports.REINSTALL_BUTTON_ID = "reinstallButton";
// GA4 analytics
exports.GA4_EVENT = "GTM event to GA";
exports.GA4_EVENT_SITE_TYPE = "web";
exports.GA4_LOGGED_IN = "logged_in";
exports.GA4_NOT_LOGGED_IN = "not_logged_in";
exports.GA4_ANONYMOUS = "anonymous";
exports.CALL_TO_ACTION_TEXT = "callToActionText";
exports.CLICK_ORIGIN = "sectionHero";
// Google Sign
exports.GOOGLE_CLIENT_ID_STG = "399782270444-tdmj14ckfmpu5kpq2b7n1723r7l855qu.apps.googleusercontent.com";
exports.GOOGLE_CLIENT_ID_PROD = "527812706492-f63ob427ei5uru7jton0bn4b8aeon0i6.apps.googleusercontent.com";
